"use strict";

exports.__esModule = true;
exports.default = void 0;
var _consts = require("../consts");
const getButtonLinkTypeToken = (name, type, theme) => {
  const tokens = {
    [_consts.TOKENS.background]: {
      [_consts.TYPES.PRIMARY]: theme.orbit.backgroundButtonLinkPrimary,
      [_consts.TYPES.SECONDARY]: theme.orbit.backgroundButtonLinkSecondary,
      [_consts.TYPES.CRITICAL]: theme.orbit.backgroundButtonLinkCritical
    },
    [_consts.TOKENS.backgroundHover]: {
      [_consts.TYPES.PRIMARY]: theme.orbit.backgroundButtonLinkPrimaryHover,
      [_consts.TYPES.SECONDARY]: theme.orbit.backgroundButtonLinkSecondaryHover,
      [_consts.TYPES.CRITICAL]: theme.orbit.backgroundButtonLinkCriticalHover
    },
    [_consts.TOKENS.backgroundActive]: {
      [_consts.TYPES.PRIMARY]: theme.orbit.backgroundButtonLinkPrimaryActive,
      [_consts.TYPES.SECONDARY]: theme.orbit.backgroundButtonLinkSecondaryActive,
      [_consts.TYPES.CRITICAL]: theme.orbit.backgroundButtonLinkCriticalActive
    },
    [_consts.TOKENS.foreground]: {
      [_consts.TYPES.PRIMARY]: theme.orbit.colorTextButtonLinkPrimary,
      [_consts.TYPES.SECONDARY]: theme.orbit.colorTextButtonLinkSecondary,
      [_consts.TYPES.CRITICAL]: theme.orbit.colorTextButtonLinkCritical
    },
    [_consts.TOKENS.foregroundHover]: {
      [_consts.TYPES.PRIMARY]: theme.orbit.colorTextButtonLinkPrimaryHover,
      [_consts.TYPES.SECONDARY]: theme.orbit.colorTextButtonLinkSecondaryHover,
      [_consts.TYPES.CRITICAL]: theme.orbit.colorTextButtonLinkCriticalHover
    },
    [_consts.TOKENS.foregroundActive]: {
      [_consts.TYPES.PRIMARY]: theme.orbit.colorTextButtonLinkPrimaryActive,
      [_consts.TYPES.SECONDARY]: theme.orbit.colorTextButtonLinkSecondaryActive,
      [_consts.TYPES.CRITICAL]: theme.orbit.colorTextButtonLinkCriticalActive
    }
  };
  return tokens[name][type];
};
var _default = getButtonLinkTypeToken;
exports.default = _default;